// @ts-nocheck
import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { quantityInputStyles } from "@store/Themes/common/mixins/form";
import { css } from "styled-components";

Object.assign(productQuantityOrderedStyles, {
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            &&&& {
                width: auto;
                margin-top: 0;
            }
        `,
        inputSelect: css`
            ${quantityInputStyles()}
        `,
    },
    labelProps: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.tiny};
            font-weight: ${x => x.theme.design.typography.weight.base};
            min-height: unset;
        `,
    },
});
